import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import Spin from '../../../components/loading';
import RseeTimePicker from '../../../components/timePicker';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import './styles.scss';
import styles from './styles.scss';
import * as cafeActions from '../../../redux/cafes/actions';
import * as introducedCafesActions from '../../../redux/introducedCafes/actions';
import {
  validator,
  formatter,
  domManipulator,
  dataGenerator,
  enumHelper,
  toastMessage,
} from '../../../utils';

import ENUMS from '../../../enums';
import FailedMessagesList from '../../../components/failedMesasgesList';
import AddOrEditCafeContext from './AddOrEditCafeContext';
import TablesList from './TablesList';
import ContactsList from './ContactsList';
import AddOrEditTableModal from './modals/AddOrEditTable';
import AddOrEditContactModal from './modals/AddOrEditContact';
import AddOrEditWorkingHourModal from './modals/AddOrEditWorkingHour';
import MapComponent from '../../../components/map';
import WorkingHoursList from './WorkingHoursList';
import ImageUploader from '../../../components/imageUploader';

class AddOrEditCafe extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cityId: '',
      name: '',
      nameInputValidateStatus: '',
      nameInputInvalidMessage: '',
      ownerFullName: '',
      ownerFullNameInputValidateStatus: '',
      ownerFullNameInputInvalidMessage: '',
      rseePercent: '0',
      // rseePercentInputValidateStatus: '',
      // rseePercentInputInvalidMessage: '',
      minCheckout: 0,
      minCheckoutInputInvalidMessage: '',
      minCheckoutInputValidateStatus: '',
      regions: [],
      regionsInputInvalidMessage: '',
      regionsInputValidateStatus: '',
      tables: [],
      longitude: '',
      latitude: '',
      latlngHelpText: '',
      latlngValidateStatus: '',
      address: '',
      description: '',
      amenities: [],
      workingHours: [],
      contacts: [],
      logoFileName: '',
      locationTableFileName: '',
      logoUrl: '',
      locationTableUrl: '',
      contractNumber: '',
      cafeContractId: undefined,
      displayTableModal: false,
      tableModalEditMode: false,
      tableModalEditData: {
        itemKey: '',
        num: '1',
        numInputInvalidMessage: '',
        numInputValidateStatus: '',
        totalChairs: '1',
        allowSmoking: false,
        haveHeatSystem: false,
        floor: ENUMS.TABLE_FLOORS.values.GROUND_LEVEL,
        location: ENUMS.TABLE_LOCATIONS.values.SALON,
        tableTitle: '',
        hasCoolingSystem: false,
        hasFogSpray: false,
        hasInput: false,
        inputAmount: '',
      },
      tableModalRenderFlag: 1,

      contactModalEditMode: false,
      isContactModalOpen: false,
      contactModalEditData: {
        itemKey: '',
        type: '',
        value: '',
      },

      workingHourModalEditMode: false,
      isWorkingHourModalOpen: false,
      workingHourModalEditData: {
        itemKey: '',
        day: '',
        fromTime: '',
        toTime: '',
      },

      cafeImages: [],
      cafeLogo: null,
      loaded: false,

      defaultRegions: [],
      defaultAmenities: [],

      prePayForEachPersonPerHour: 0,
      prePayForEachPersonPerHourInvalidMessage: '',
      prePayForEachPersonPerHourValidStatus: '',

      currency: ENUMS.CURRENCY.values.TOMAN,

      hasBreakfast: false,
      hasLunch: false,
      hasDinner: false,
      breakfastFromTime: '00:00',
      breakfastToTime: '00:00',
      lunchFromTime: '00:00',
      lunchToTime: '00:00',
      dinnerFromTime: '00:00',
      dinnerToTime: '00:00',
      breakfastInputError: '',
      lunchInputError: '',
      dinnerInputError: '',
      totalCafeTables: '0',
      totalRseeTables: 0,
      rseeStockType: 'RSEE_PERCENT',
      rseeConstantAmount: 0,
      rseeConstantAmountInputValidateStatus: '',
      rseeConstantAmountInputInvalidMessage: '',
      cafeType: 'NORMAL',
      chargeAmountFor3Month: '',
      chargeAmountFor3MonthInputValidateStatus: '',
      chargeAmountFor3MonthInputInvalidMessage: '',
      timeInterval: 60,

      hasNoReservationFee: false,
    };
  }

  componentWillMount() {
    window.scrollTo(0, 0);

    this.props.actions.clearForm();

    if (
      this.props.location.pathname === '/cafes/edit' &&
      !(
        this.props.editMode &&
        this.props.location &&
        this.props.location.cafeId
      )
    ) {
      return this.props.history.push('/cafes');
    } else if (this.props.location.pathname === '/cafes/edit') {
      this.props.actions.getCafeById(this.props.location.cafeId);
    }

    this.props.actions.getAmenities();
    this.props.actions.getCafeContract();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      this.props.editMode &&
      prevState.loaded === false &&
      !!this.props.fetchedCafeById
    ) {
      const {
        mealsInfo,
        manHourPrepaidPrice,
        name,
        currency,
        ownerFullName,
        // rseePercent,
        description,
        address,
        latitude,
        longitude,
        regions,
        amenities,
        contacts,
        workingHours,
        cafeContractId,
        tables,
        logoUrl,
        locationTableUrl,
        cafeImages,
        contractNumber,
        totalCafeTables,
        totalRseeTables,
        minCheckout,
        rseeStockType,
        rseeConstantAmount,
        cafeType,
        chargeAmountFor3Month,
        timeInterval,
        cityId,
        hasNoReservationFee,
      } = this.props.fetchedCafeById;

      let id = cityId;
      let query = `pageNumber=${1}&pageSize=${200}`;
      this.props.actions.getRegions(id, query);

      tables?.map(tables => {
        if (tables.inputAmount) {
          tables.hasInput = true;
        }
      });

      let mappedRegions = [];
      if (regions && regions.length) {
        mappedRegions = regions.map(x => ({
          value: x.id,
          label: x.name,
        }));
      }

      let mappedAmenities = [];
      if (amenities && amenities.length) {
        mappedAmenities = amenities.map(x => ({
          value: x.id,
          label: x.name,
        }));
      }

      let workingHoursWithClientKeys = [];
      if (workingHours && workingHours.length) {
        workingHoursWithClientKeys = workingHours.map(x => ({
          ...x,
          itemKey: dataGenerator.generateKey('working_hour'),
        }));
      }

      let contactsWithClientKeys = [];
      if (contacts && contacts.length) {
        contactsWithClientKeys = contacts.map(x => ({
          ...x,
          itemKey: dataGenerator.generateKey('contact_item'),
        }));
      }

      let tablesWithClientKeys = [];
      if (tables && tables.length) {
        tablesWithClientKeys = tables.map(x => ({
          ...x,
          itemKey: dataGenerator.generateKey('table'),
        }));
      }

      let cafeImagesWithClientKeys = [];
      if (cafeImages && cafeImages.length) {
        cafeImagesWithClientKeys = cafeImages.map(x => ({
          ...x,
          key: dataGenerator.generateKey('table'),
        }));
      }

      let hasBreakfast = false;
      let hasLunch = false;
      let hasDinner = false;
      let breakfastFromTime = '00:00';
      let breakfastToTime = '00:00';
      let lunchFromTime = '00:00';
      let lunchToTime = '00:00';
      let dinnerFromTime = '00:00';
      let dinnerToTime = '00:00';
      if (mealsInfo && mealsInfo.length) {
        mealsInfo.forEach(item => {
          if (item.meal === 'BREAKFAST') {
            hasBreakfast = true;
            breakfastFromTime = item.fromTime;
            breakfastToTime = item.toTime;
          } else if (item.meal === 'LUNCH') {
            hasLunch = true;
            lunchFromTime = item.fromTime;
            lunchToTime = item.toTime;
          } else if (item.meal === 'DINNER') {
            hasDinner = true;
            dinnerFromTime = item.fromTime;
            dinnerToTime = item.toTime;
          }
        });
      }

      this.setState(() => ({
        loaded: true,
        cityId,
        name,
        prePayForEachPersonPerHour: manHourPrepaidPrice,
        ownerFullName,
        // rseePercent,
        description,
        address,
        latitude,
        longitude,
        currency,
        regions: mappedRegions,
        amenities: mappedAmenities,
        contacts: contactsWithClientKeys,
        workingHours: workingHoursWithClientKeys,
        tables: tablesWithClientKeys,
        cafeContractId,
        logoFileName: '',
        locationTableFileName: '',
        logoUrl,
        locationTableUrl,
        cafeImages: cafeImagesWithClientKeys,
        hasBreakfast,
        hasLunch,
        hasDinner,
        breakfastFromTime,
        breakfastToTime,
        lunchFromTime,
        lunchToTime,
        dinnerFromTime,
        dinnerToTime,
        contractNumber,
        totalCafeTables,
        totalRseeTables,
        minCheckout,
        // rseeStockType,
        rseeConstantAmount,
        cafeType,
        chargeAmountFor3Month,
        timeInterval,
        hasNoReservationFee,
      }));
    }
  }

  addTableItem = tableData => {
    this.setState(prevState => ({
      tables: [...prevState.tables, { ...tableData }],
    }));
  };

  editContactItem = contactItem => {
    let contacts = this.state.tables;
    for (let i = 0; i < contacts.length; i++) {
      if (contacts[i].itemKey == contactItem.itemKey) {
        contacts[i] = {
          ...contacts[i],
          ...contactItem,
        };
        break;
      }
    }

    this.setState(() => ({
      contacts: [...contacts],
    }));
  };

  editTableItem = tableData => {
    let tables = this.state.tables;
    for (let i = 0; i < tables.length; i++) {
      if (tables[i].itemKey == tableData.itemKey) {
        tables[i] = {
          ...tables[i],
          ...tableData,
        };
        break;
      }
    }

    this.setState(() => ({
      tables: [...tables],
    }));
  };

  onSelectCafeLocation = coordinate => {
    this.setState(() => ({
      latitude: coordinate.lat,
      longitude: coordinate.lng,
      latlngHelpText: '',
      latlngValidateStatus: '',
    }));
  };

  // onOwnerFullNameChange = e => {
  //   const ownerFullName = e.target.value;

  //   if (
  //     !ownerFullName ||
  //     validator.hasMaxLength(ownerFullName, { maxLength: 64 })
  //   ) {
  //     this.setState(() => ({
  //       ownerFullName,
  //       ownerFullNameInputInvalidMessage: '',
  //       ownerFullNameInputValidateStatus: '',
  //     }));
  //   }
  // };

  onRseePercentChange = e => {
    const rseePercent = e.target.value;

    if (!rseePercent || (rseePercent >= 0 && rseePercent <= 100)) {
      this.setState(() => ({
        rseePercent,
        rseePercentInputInvalidMessage: '',
        rseePercentInputValidateStatus: '',
      }));
    }
  };

  onRseeConstantAmountChange = e => {
    const rseeConstantAmount = new Intl.NumberFormat().format(
      e.target.value.replaceAll(',', ''),
    );
    this.setState({
      rseeConstantAmount:
        rseeConstantAmount === 'NaN' ? '' : rseeConstantAmount,
      rseeConstantAmountInputInvalidMessage: '',
      rseeConstantAmountInputValidateStatus: '',
    });
  };

  onchargeChange = event => {
    const charge = new Intl.NumberFormat().format(
      event.target.value.replaceAll(',', ''),
    );
    this.setState({
      chargeAmountFor3Month: charge === 'NaN' ? '' : charge,
      chargeAmountFor3MonthInputInvalidMessage: '',
      chargeAmountFor3MonthInputValidateStatus: '',
    });
  };

  onMinCheckoutCHange = e => {
    const minCheckout = e.target.value;

    if (!minCheckout || (minCheckout >= 0 && minCheckout <= 100)) {
      this.setState(() => ({
        minCheckout,
        minCheckoutInputInvalidMessage: '',
        minCheckoutInputValidateStatus: '',
      }));
    }
  };

  onAddressChange = e => {
    const address = e.target.value;

    if (!address || validator.hasMaxLength(address, { maxLength: 512 })) {
      this.setState(() => ({ address }));
    }
  };

  onDescriptionChange = e => {
    const description = e.target.value;

    if (
      !description ||
      validator.hasMaxLength(description, { maxLength: 512 })
    ) {
      this.setState(() => ({ description }));
    }
  };

  validateForm = () => {
    return new Promise((resolve, reject) => {
      const standardName = formatter.toStandard(this.state.name);
      // const standardRseePercent = formatter.toStandard(this.state.rseePercent);
      const standardMinCheckout = formatter.toStandard(
        String(this.state.minCheckout).replaceAll(',', ''),
      );
      const standardOwnerFullName = formatter.toStandard(
        this.state.ownerFullName,
      );
      const standardPrePayForEachPersonPerHout = formatter.toStandard(
        String(this.state.prePayForEachPersonPerHour).replaceAll(',', ''),
      );
      const standardChargeAmountFor3Month = formatter.toStandard(
        String(this.state.chargeAmountFor3Month).replaceAll(',', ''),
      );

      let isNameValid;
      let isOwnerFullNameValid;
      // let isRseePercentValid;
      let isMinCheckoutValid;
      let isRegionsValid;
      let isPrePayValid;
      let isChargeAmountFor3MonthValid;
      let firstErrorElementId = '';
      let errors = {};

      if (!standardName) {
        errors.nameInputInvalidMessage = locales(
          'messages.fieldValueIsRequired',
          {
            fieldName: locales('fields.cafe.name'),
          },
        );
        errors.nameInputValidateStatus = 'is-invalid';
        firstErrorElementId = 'name';
        isNameValid = false;
      } else {
        errors.nameInputInvalidMessage = '';
        errors.nameInputValidateStatus = '';
        isNameValid = true;
      }

      if (!standardOwnerFullName) {
        errors.ownerFullNameInputInvalidMessage = locales(
          'messages.fieldValueIsRequired',
          {
            fieldName: locales('fields.cafe.owner.full.name'),
          },
        );
        errors.ownerFullNameInputValidateStatus = 'is-invalid';
        firstErrorElementId = 'ownerFullName';
        isOwnerFullNameValid = false;
      } else {
        errors.ownerFullNameInputInvalidMessage = '';
        errors.ownerFullNameInputValidateStatus = '';
        isOwnerFullNameValid = true;
      }

      // if (this.state.cafeType === 'NORMAL' &&
      //   this.state.rseeStockType === 'RSEE_PERCENT' &&
      //   !standardRseePercent) {
      //   errors.rseePercentInputInvalidMessage = locales('messages.fieldValueIsRequired',
      //     {
      //       fieldName: locales('fields.rsee.percent'),
      //     },
      //   );
      //   errors.rseePercentInputValidateStatus = 'is-invalid';
      //   firstErrorElementId = 'rseePercent';
      //   isRseePercentValid = false;
      // } else {
      //   errors.rseePercentInputInvalidMessage = '';
      //   errors.rseePercentInputValidateStatus = '';
      //   isRseePercentValid = true;
      // }

      if (
        this.state.cafeType === 'TAKEAWAY' &&
        !standardChargeAmountFor3Month
      ) {
        errors.chargeAmountFor3MonthInputInvalidMessage = locales(
          'messages.fieldValueIsRequired',
          {
            fieldName: locales('three.month.charge.amount'),
          },
        );
        errors.chargeAmountFor3MonthInputValidateStatus = 'is-invalid';
        firstErrorElementId = 'chargeAmountFor3Month';
        isChargeAmountFor3MonthValid = false;
      } else {
        errors.chargeAmountFor3MonthInputInvalidMessage = '';
        errors.chargeAmountFor3MonthInputValidateStatus = '';
        isChargeAmountFor3MonthValid = true;
      }

      if (this.state.cafeType === 'NORMAL' && !standardMinCheckout) {
        errors.minCheckoutInputInvalidMessage = locales(
          'messages.fieldValueIsRequired',
          {
            fieldName: locales('fields.cafe.minCheckout'),
          },
        );
        errors.minCheckoutInputValidateStatus = 'is-invalid';
        firstErrorElementId = 'minCheckout';
        isMinCheckoutValid = false;
      } else {
        errors.minCheckoutInputInvalidMessage = '';
        errors.minCheckoutInputValidateStatus = '';
        isMinCheckoutValid = true;
      }

      if (
        this.state.cafeType === 'NORMAL' &&
        !standardPrePayForEachPersonPerHout
      ) {
        errors.prePayForEachPersonPerHourInvalidMessage = locales(
          'messages.fieldValueIsRequired',
          {
            fieldName: locales('titles.prePayForEachPersonPerHour'),
          },
        );
        errors.prePayForEachPersonPerHourValidStatus = 'is-invalid';
        firstErrorElementId = 'prePayForEachPersonPerHout';
        isPrePayValid = false;
      } else {
        errors.prePayForEachPersonPerHourInvalidMessage = '';
        errors.prePayForEachPersonPerHourValidStatus = '';
        isPrePayValid = true;
      }

      if (!this.state.regions.length) {
        isRegionsValid = false;
        firstErrorElementId = 'regions';
        errors.regionsInputInvalidMessage = locales(
          'messages.selectOneRegionsIsMandatory',
        );
        errors.regionsInputValidateStatus = 'is-invalid';
      } else {
        isRegionsValid = true;
        errors.regionsInputInvalidMessage = '';
        errors.regionsInputValidateStatus = '';
      }

      const isFormValid =
        isNameValid &&
        isOwnerFullNameValid &&
        // isRseePercentValid &&
        isMinCheckoutValid &&
        isPrePayValid &&
        isRegionsValid &&
        isChargeAmountFor3MonthValid;

      if (!isFormValid) {
        this.setState(
          () => ({
            ...errors,
          }),
          () => {
            domManipulator.scrollIntoView(firstErrorElementId);
            resolve(false);
          },
        );
      } else {
        resolve(true);
      }
    });
  };

  changePrePayForEachPersonPerHour = event => {
    let { value } = event.target;

    if (
      !value ||
      (validator.isNumber(value.replaceAll(',', '')) &&
        value.replaceAll(',', ''))
    ) {
      const val = new Intl.NumberFormat().format(value.replaceAll(',', ''));
      this.setState({ prePayForEachPersonPerHour: val });
    }
  };

  changeMealPortions = meals => {
    let hasBreakfast = false;
    let hasLunch = false;
    let hasDinner = false;
    let breakfastFromTime = this.state.breakfastFromTime;
    let breakfastToTime = this.state.breakfastToTime;
    let lunchFromTime = this.state.lunchFromTime;
    let lunchToTime = this.state.lunchToTime;
    let dinnerFromTime = this.state.dinnerFromTime;
    let dinnerToTime = this.state.dinnerToTime;
    if (meals && meals.length) {
      meals.forEach(item => {
        if (item.value === 'BREAKFAST') {
          hasBreakfast = true;
        } else if (item.value === 'LUNCH') {
          hasLunch = true;
        } else if (item.value === 'DINNER') {
          hasDinner = true;
        }
      });
    }
    if (!hasBreakfast) {
      breakfastFromTime = '00:00';
      breakfastToTime = '00:00';
    }
    if (!hasLunch) {
      lunchFromTime = '00:00';
      lunchToTime = '00:00';
    }
    if (!hasDinner) {
      dinnerFromTime = '00:00';
      dinnerToTime = '00:00';
    }
    this.setState({
      meals,
      hasBreakfast,
      hasLunch,
      hasDinner,
      breakfastFromTime,
      breakfastToTime,
      lunchFromTime,
      lunchToTime,
      dinnerFromTime,
      dinnerToTime,
    });
  };

  saveForm = async event => {
    event.preventDefault();

    const isFormValid = await this.validateForm();
    if (!isFormValid) {
      return;
    }
    domManipulator.scrollToTop();

    const standardName = formatter.toStandard(this.state.name);
    const standardOwnerFullName = formatter.toStandard(
      this.state.ownerFullName,
    );
    // const standardRseePercent = formatter.toStandard(this.state.rseePercent);
    const standardRseeConstantAmount = formatter.toStandard(
      String(this.state.rseeConstantAmount).replaceAll(',', ''),
    );
    const standardChargeAmountFor3Month = formatter.toStandard(
      String(this.state.chargeAmountFor3Month).replaceAll(',', ''),
    );
    const standardMinCheckout = formatter.toStandard(
      String(this.state.minCheckout).replaceAll(',', ''),
    );
    const standardDescription = formatter.toStandard(this.state.description);
    const standardAddress = formatter.toStandard(this.state.address);
    const standardPrePayForEachPersonPerHout = formatter.toStandard(
      String(this.state.prePayForEachPersonPerHour).replaceAll(',', ''),
    );
    const standardContractNumber = formatter.toStandard(
      this.state.contractNumber,
    );
    const standardTotalCafeTables = formatter.toStandard(
      this.state.totalCafeTables,
    );
    const standardTotalRseeTables = formatter.toStandard(
      this.state.totalRseeTables,
    );

    const standardTimeInterval = formatter.toStandard(this.state.timeInterval);

    let {
      latitude,
      longitude,
      regions,
      amenities,
      contacts,
      workingHours,
      tables,
      logoFileName,
      locationTableFileName,
      logoUrl,
      locationTableUrl,
      cafeImages,
      hasBreakfast,
      hasLunch,
      hasDinner,
      cafeContractId,
      breakfastFromTime,
      breakfastToTime,
      lunchFromTime,
      lunchToTime,
      dinnerFromTime,
      dinnerToTime,
      minCheckout,
      timeInterval,
      hasNoReservationFee,
    } = this.state;

    const mealsInfo = [];
    if (hasBreakfast) {
      mealsInfo.push({
        meal: ENUMS.MEAL_PORTIONS.values.BREAKFAST,
        fromTime: breakfastFromTime,
        toTime: breakfastToTime,
      });
    }
    if (hasLunch) {
      mealsInfo.push({
        meal: ENUMS.MEAL_PORTIONS.values.LUNCH,
        fromTime: lunchFromTime,
        toTime: lunchToTime,
      });
    }
    if (hasDinner) {
      mealsInfo.push({
        meal: ENUMS.MEAL_PORTIONS.values.DINNER,
        fromTime: dinnerFromTime,
        toTime: dinnerToTime,
      });
    }

    let cafeObject = {
      meals: [...mealsInfo.map(item => item.meal)],
      mealsInfo,
      manHourPrepaidPrice: standardPrePayForEachPersonPerHout,
      name: standardName,
      ownerFullName: standardOwnerFullName,
      rseePercent: '0',
      rseeConstantAmount: standardRseeConstantAmount,
      chargeAmountFor3Month: Number(standardChargeAmountFor3Month),
      minCheckout: standardMinCheckout,
      description: standardDescription,
      address: standardAddress,
      cafeContractId,
      latitude,
      longitude,
      regionIds: regions && regions.length && regions.map(x => x.value),
      amenityIds: amenities && amenities.length && amenities.map(x => x.value),
      contacts,
      workingHours,
      tables,
      logoFileName,
      locationTableFileName,
      locationTableUrl,
      logoUrl,
      cafeImages,
      contractNumber: standardContractNumber,
      totalCafeTables: standardTotalCafeTables,
      totalRseeTables: standardTotalRseeTables,
      timeInterval,
    };

    this.state.cafeType === 'NORMAL' &&
      (cafeObject = { ...cafeObject, hasNoReservationFee });

    if (this.props.editMode === true) {
      cafeObject = {
        ...cafeObject,
        id: this.props.location.cafeId,
      };
      this.props.actions
        .updateCafe(cafeObject)
        .then(() => {
          this.props.history.push('/cafes');
          toastMessage.show({
            text: locales('titles.editionsDoneSuccessfully'),
            icon: 'success',
          });
        })
        .catch(err => console.error(err));
    } else {
      this.props.actions
        .insertNewCafe(cafeObject)
        .then(() => {
          if (this.props.location.introducedCafe) {
            let data = {
              id: this.props.location.id,
              status: this.props.location.status,
            };
            this.props.actions
              .changeCafeStatus(data.status, '', data.id)
              .then(() => {
                this.props.history.push('/introduced-cafes');
                toastMessage.show({
                  text: locales('titles.insertedSuccessfully'),
                  icon: 'success',
                });
              });
          } else {
            this.props.history.push('/cafes');
            toastMessage.show({
              text: locales('titles.insertedSuccessfully'),
              icon: 'success',
            });
          }
        })
        .catch(err => console.error(err));
    }
  };

  onUploadLogoSuccess = uploadedFile => {
    this.setState(() => ({
      logoFileName: uploadedFile.fileName,
      logoUrl: uploadedFile.url,
    }));
  };

  onUploadLocationTableSuccess = uploadedFile => {
    this.setState(() => ({
      locationTableFileName: uploadedFile.fileName,
      locationTableUrl: uploadedFile.url,
    }));
  };

  onUploadCafeImagesSuccess = uploadedCafeImages => {
    this.setState(() => ({
      cafeImages: [...this.state.cafeImages, ...uploadedCafeImages],
    }));
  };

  deleteCafeImage = key => {
    const filteredCafeImages = this.state.cafeImages.filter(x => x.key !== key);
    this.setState(() => ({
      cafeImages: filteredCafeImages,
    }));
  };

  deleteLogo = _ => {
    this.setState(() => ({
      logoUrl: null,
      logoFileName: null,
    }));
  };

  deleteLocationTable = _ => {
    this.setState(() => ({
      locationTableUrl: null,
      locationTableFileName: null,
    }));
  };

  displayAddTableItemModal = () => {
    if (this.state.cafeType === 'NORMAL') {
      this.setState(() => ({
        displayTableModal: true,
        tableModalEditMode: false,
        isTableNumDuplicate: false,
        tableModalEditData: {
          itemKey: '',
          num: '1',
          numInputInvalidMessage: '',
          numInputValidateStatus: '',
          totalChairs: '1',
          allowSmoking: false,
          haveHeatSystem: false,
          floor: ENUMS.TABLE_FLOORS.values.GROUND_LEVEL,
          location: ENUMS.TABLE_LOCATIONS.values.SALON,
          tableTitle: '',
          hasCoolingSystem: false,
          hasFogSpray: false,
          hasInput: false,
          inputAmount: '',
        },
        tableModalRenderFlag: this.state.tableModalRenderFlag + 1,
      }));
    } else if (this.state.cafeType === 'TAKEAWAY') {
      this.setState(prevState => ({
        displayTableModal: false,
        tableModalEditMode: false,
      }));
    }
  };

  deleteTableItem = (status, itemKey) => {
    this.handleMinusTotalRseeTables();

    let tables = this.state.tables;
    const index = tables.findIndex(table => table.itemKey == itemKey);
    if (status === 'ACTIVE') {
      tables[index] = { ...tables[index], isDeleted: false };
    } else {
      tables[index] = { ...tables[index], isDeleted: true };
    }

    this.setState(() => ({
      tables: [...tables],
    }));
  };

  isTableNumDuplicate = (num, excludedNum) => {
    if (excludedNum) {
      const found = this.state.tables
        .filter(x => x.num !== excludedNum)
        .find(x => x.num === num);
      return found;
    }

    return this.state.tables.find(x => x.num === num);
  };

  displayEditTableItemModal = tableItemKey => {
    const foundTableItem = this.state.tables.find(
      x => x.itemKey === tableItemKey,
    );

    this.setState(prevState => ({
      displayTableModal: true,
      tableModalEditMode: true,
      isTableNumDuplicate: false,
      tableModalRenderFlag: this.state.tableModalRenderFlag + 1,
      tableModalEditData: {
        itemKey: foundTableItem.itemKey,
        num: foundTableItem.num,
        totalChairs: foundTableItem.totalChairs,
        allowSmoking: foundTableItem.allowSmoking,
        haveHeatSystem: foundTableItem.haveHeatSystem,
        floor: foundTableItem.floor,
        location: foundTableItem.location,
        tableTitle: foundTableItem.tableTitle,
        hasCoolingSystem: foundTableItem.hasCoolingSystem,
        hasFogSpray: foundTableItem.hasFogSpray,
        hasInput: foundTableItem.hasInput,
        inputAmount: foundTableItem.inputAmount,
      },
    }));
  };

  closeTableModal = () => {
    this.setState(() => ({
      displayTableModal: false,
    }));
  };

  displayContactModal = () => {
    this.setState(() => ({
      isContactModalOpen: true,
      contactModalEditMode: false,
      contactModalEditData: {
        itemKey: '',
        type: '',
        value: '',
      },
    }));
  };

  closeContactModal = () => {
    this.setState(() => ({
      isContactModalOpen: false,
    }));
  };

  onSelectAmenities = selectedItems => {
    this.setState(() => ({
      amenities: selectedItems,
    }));
  };

  onSelectRegions = selectedItems => {
    this.setState(() => ({
      regions: selectedItems,
      regionsInputInvalidMessage: '',
      regionsInputValidateStatus: '',
    }));
  };

  addContactItem = contactItem => {
    this.setState(prevState => ({
      contacts: [...prevState.contacts, { ...contactItem }],
    }));
  };

  editContactItem = contactItem => {
    let contacts = this.state.contacts;

    for (let i = 0; i < contacts.length; i++) {
      if (contacts[i].itemKey == contactItem.itemKey) {
        contacts[i] = {
          ...contactItem,
          itemKey: contactItem.itemKey,
        };
        break;
      }
    }

    this.setState(() => ({
      contacts: [...contacts],
    }));
  };

  isContactItemDuplicate = ({ type, value, excludedContactValue = null }) => {
    if (excludedContactValue) {
      const found = !!this.state.contacts
        .filter(x => x.type === type && x.value !== excludedContactValue)
        .find(x => x.value === value);
      return found;
    }

    const found = !!this.state.contacts.find(
      x => x.type === type && x.value === value,
    );
    return found;
  };

  deleteContactItem = itemKey => {
    this.setState(prevState => ({
      contacts: prevState.contacts.filter(x => x.itemKey !== itemKey),
    }));
  };

  displayEditContactItemModal = contactItemKey => {
    const foundContactItem = this.state.contacts.find(
      x => x.itemKey === contactItemKey,
    );

    this.setState(() => ({
      isContactModalOpen: true,
      contactModalEditMode: true,
      contactModalEditData: {
        itemKey: foundContactItem.itemKey,
        value: foundContactItem.value,
        type: foundContactItem.type,
      },
    }));
  };

  addWorkingHourItem = workingHourItem => {
    this.setState(prevState => ({
      workingHours: [...prevState.workingHours, { ...workingHourItem }],
    }));
  };

  editWorkingHourItem = workingHourItem => {
    let workingHours = [...this.state.workingHours];

    for (let i = 0; i < workingHours.length; i++) {
      if (workingHours[i].itemKey == workingHourItem.itemKey) {
        workingHours[i] = {
          ...workingHours[i],
          ...workingHourItem,
        };
        break;
      }
    }

    this.setState(() => ({
      workingHours: [...workingHours],
    }));
  };

  isWorkingHourItemDuplicate = ({
    day,
    fromTime,
    endTime,
    excludedContactValue = null,
  }) => {
    let foundInterfere = !!this.state.workingHours.find(
      x => x.day === day && x.fromTime <= fromTime && x.endTime >= fromTime,
    );
    foundInterfere =
      foundInterfere ||
      !!this.state.workingHours.find(
        x => x.day === day && x.endTime >= fromTime && x.endTime <= endTime,
      );
    return foundInterfere;
  };

  deleteWorkingHourItem = workingHourItemKey => {
    this.setState(prevState => ({
      workingHours: prevState.workingHours.filter(
        x => x.itemKey !== workingHourItemKey,
      ),
    }));
  };

  displayAddWorkingHourModal = () => {
    this.setState(() => ({
      isWorkingHourModalOpen: true,
      workingHourModalEditMode: false,
      workingHourModalEditData: {
        itemKey: '',
        day: '',
        fromTime: '',
        toTime: '',
      },
    }));
  };

  displayEditWorkingHourItemModal = workingHourItemKey => {
    const foundWorkingHourItem = this.state.workingHours.find(
      x => x.itemKey === workingHourItemKey,
    );

    this.setState(() => ({
      isWorkingHourModalOpen: true,
      workingHourModalEditMode: true,
      workingHourModalEditData: {
        itemKey: foundWorkingHourItem.itemKey,
        day: foundWorkingHourItem.day,
        fromTime: foundWorkingHourItem.fromTime,
        toTime: foundWorkingHourItem.toTime,
      },
    }));
  };

  closeWorkingHourModal = () => {
    this.setState(() => ({
      isWorkingHourModalOpen: false,
    }));
  };

  onChangeHasBreakfast = event => {
    this.setState({
      hasBreakfast: event.target.checked,
      breakfastInputError: null,
    });
    if (!event.target.checked) {
      this.setState({ breakfastFromTime: null, breakfastToTime: null });
    }
  };

  onChangeHasLunch = event => {
    this.setState({ hasLunch: event.target.checked, lunchInputError: null });
    if (!event.target.checked) {
      this.setState({ lunchFromTime: null, lunchToTime: null });
    }
  };

  onChangeHasDinner = event => {
    this.setState({ hasDinner: event.target.checked, dinnerInputError: null });
    if (!event.target.checked) {
      this.setState({ dinnerFromTime: null, dinnerToTime: null });
    }
  };

  onChangeBreakfastFromTime = selectedTime => {
    this.setState({ breakfastFromTime: selectedTime });
    if (selectedTime < breakfastToTime) {
      this.setState({ breakfastInputError: null });
    }
  };

  onChangeBreakfastToTime = selectedTime => {
    this.setState({ breakfastToTime: selectedTime });
    if (selectedTime > breakfastFromTime) {
      this.setState({ breakfastInputError: null });
    }
  };

  onChangeLunchFromTime = selectedTime => {
    this.setState({ lunchFromTime: selectedTime });
    if (selectedTime < lunchToTime) {
      this.setState({ lunchInputError: null });
    }
  };

  onChangeLunchToTime = selectedTime => {
    this.setState({ lunchToTime: selectedTime });
    if (selectedTime > lunchFromTime) {
      this.setState({ lunchInputError: null });
    }
  };

  onChangeDinnerFromTime = selectedTime => {
    this.setState({ dinnerFromTime: selectedTime });
    if (selectedTime < dinnerToTime) {
      this.setState({ dinnerInputError: null });
    }
  };

  onChangeDinnerToTime = selectedTime => {
    this.setState({ dinnerToTime: selectedTime });
    if (selectedTime > dinnerFromTime) {
      this.setState({ dinnerInputError: null });
    }
  };

  onNameChange = selected => {
    const name = selected.label;
    const contractNumber = selected.contractNumber;
    const ownerFullName = selected.cafeManagerName;
    const cafeContractId = selected.id;
    const cityId = selected.cityId;
    // const rseeStockType = selected.rseeStockType;
    const cafeType = selected.cafeType;

    if (!name || validator.hasMaxLength(name, { maxLength: 64 })) {
      this.setState(() => ({
        name,
        contractNumber,
        ownerFullName,
        cafeContractId,
        // rseeStockType,
        cafeType,
        cityId,
      }));
    }
    if (cafeType === 'NORMAL') {
      this.setState(() => ({
        chargeAmountFor3MonthInputValidateStatus: '',
        chargeAmountFor3MonthInputInvalidMessage: '',
      }));
    }
    if (cafeType === 'TAKEAWAY') {
      this.setState(() => ({
        prePayForEachPersonPerHourInvalidMessage: '',
        prePayForEachPersonPerHourValidStatus: '',
        minCheckoutInputInvalidMessage: '',
        minCheckoutInputValidateStatus: '',
        // rseePercentInputValidateStatus: '',
        // rseePercentInputInvalidMessage: '',
        rseeConstantAmountInputValidateStatus: '',
        rseeConstantAmountInputInvalidMessage: '',
      }));
    }

    let id = cityId;
    let query = `pageNumber=${1}&pageSize=${500}`;
    this.props.actions.getRegions(id, query);
  };

  onTimeIntervalChange = selected => {
    const timeDuration = selected.value;

    this.setState({ timeInterval: timeDuration });
  };

  // handleChangeContractNumber = e => {
  //   const contractNumber = e.target.value;

  //   if (
  //     !contractNumber ||
  //     (validator.isNumber(contractNumber) && contractNumber.length <= 4)
  //   ) {
  //     this.setState(() => ({ contractNumber }));
  //   }
  // };

  // handleChangeTotalCafeTables = e => {
  //   this.setState({ totalCafeTables: e.target.value });
  // };

  handlePlusTotalRseeTables = value => {
    this.setState({ totalRseeTables: this.state.totalRseeTables + 1 });
    this.setState({ totalCafeTables: this.state.totalRseeTables + 1 });
  };

  handleMinusTotalRseeTables = value => {
    this.setState({ totalRseeTables: this.state.totalRseeTables - 1 });
  };

  onMinChekoutChange = e => {
    const val = new Intl.NumberFormat().format(
      e.target.value.replaceAll(',', ''),
    );
    this.setState({ minCheckout: val === 'NaN' ? 0 : val });
  };

  cancelForm = () => {
    if (this.props.location.introducedCafe) {
      return this.props.history.push('/introduced-cafes');
    } else {
      return this.props.history.push('/cafes');
    }
  };

  render() {
    let { prePayForEachPersonPerHour, meals, currency } = this.state;

    return (
      <AddOrEditCafeContext.Provider
        value={{
          addContactItem: this.addContactItem,
          editContactItem: this.editContactItem,
          addTableItem: this.addTableItem,
          isContactModalOpen: this.isContactModalOpen,
          addWorkingHourItem: this.addWorkingHourItem,
          editWorkingHourItem: this.editWorkingHourItem,
        }}
      >
        <Spin
          spinning={
            this.props.addOrEditCafeLoading ||
            this.props.getAmenitiesLoading ||
            this.props.getRegionsLoading
          }
          className='col-9 mt-5'
        >
          <section className='page-header'>
            <h1>{locales('titles.cafes')}</h1>
            <div className='form-actions'>
              <button
                type='submit'
                className='btn btn-success w-100'
                onClick={this.saveForm}
              >
                <i className='fa fa-save' />
                {locales('labels.save')}
              </button>
              <button
                className='btn btn-default w-100'
                type='button'
                onClick={this.cancelForm}
              >
                <i className='fa fa-reply' />
                {locales('labels.cancel')}
              </button>
            </div>
          </section>

          <section className='panel panel-default'>
            <div className='panel-heading'>
              <h3 className='panel-title'>
                <i className='fa fa-pencil'></i>
                {this.props.editMode
                  ? locales('titles.edit.cafe')
                  : locales('titles.add.new.cafe')}
              </h3>
            </div>
            <div className='panel-body'>
              <form ref='form' className='col form-horizontal'>
                <FailedMessagesList
                  className='errors-list'
                  messagesList={this.props.addOrEditCafeFailedMessagesList}
                />
                {this.props.addOrEditCafeError && (
                  <div
                    className={`errors-list ${this.props.className} alert alert-danger alert-dismissible fade show`}
                    role='alert'
                  >
                    {locales('messages.server.error')}
                  </div>
                )}
                <section>
                  <div id='cafe-info'>
                    <h6 className='cafes-line-container text-primary'>
                      <span className='line'>
                        <i className='fal fa-coffee px-1' />
                        {locales('titles.cafe.info')}
                        <i className='fal fa-coffee px-1' />
                      </span>
                    </h6>

                    <div className='form-row'>
                      <div className='form-group col-lg-4 col-md-12 col-sm-12 d-flex required'>
                        <label
                          className='rsee-form-label col-3 text-right'
                          htmlFor='cities'
                        >
                          {locales('fields.cafe.name')}
                        </label>
                        <div className='full-width'>
                          <Select
                            placeholder={
                              this.state.cafeContractId
                                ? this.state.name
                                : locales('messages.cafeName')
                            }
                            isMulti={false}
                            id='name'
                            name='name'
                            options={this.props.cafesContract?.map(x => ({
                              id: x.id,
                              value: x.id,
                              label: x.cafeName,
                              contractNumber: x.contractNumber,
                              cafeManagerName: x.cafeManagerName,
                              cafeType: x.cafeType,
                              cityId: x.cityId,
                            }))}
                            className={`rc-dropdown ${this.state.nameInputValidateStatus}`}
                            onChange={selected => {
                              this.onNameChange(selected),
                                selected.cafeType === 'TAKEAWAY' &&
                                  this.setState({ hasNoReservationFee: false });
                            }}
                            isDisabled={this.props.editMode}
                          />
                          <small className='form-text text-muted'>
                            {locales('maxLength.50')}
                          </small>
                          <div className='invalid-feedback'>
                            {this.state.nameInputInvalidMessage}
                          </div>
                        </div>
                      </div>

                      <div className='form-group col-lg-4 col-md-12 col-sm-12 d-flex required'>
                        <label
                          className='rsee-form-label col-3 text-right'
                          htmlFor='ownerFullName'
                        >
                          {locales('fields.cafe.owner.full.name')}
                        </label>
                        <div className='full-width'>
                          <input
                            id='ownerFullName'
                            name='ownerFullName'
                            type='text'
                            className={`form-control ${this.state.ownerFullNameInputValidateStatus}`}
                            // onChange={this.onOwnerFullNameChange}
                            disabled='true'
                            autoComplete='off'
                            value={this.state.ownerFullName}
                            placeholder={locales(
                              'messages.sample.cafe.owner.full.name',
                            )}
                            maxLength={ENUMS.MAX_LENGTH.fullName}
                          />
                          <small className='form-text text-muted'>
                            {locales('maxLength.50')}
                          </small>
                          <div className='invalid-feedback'>
                            {this.state.ownerFullNameInputInvalidMessage}
                          </div>
                        </div>
                      </div>

                      <div className='form-group col-lg-4 col-md-12 col-sm-12 d-flex required'>
                        <label
                          className='rsee-form-label col-3 text-right'
                          htmlFor='contractNumber'
                        >
                          {locales('fields.contractNumber')}
                        </label>
                        <div className='full-width'>
                          <input
                            id='contractNumber'
                            name='contractNumber'
                            type='text'
                            className={`form-control`}
                            // onChange={this.handleChangeContractNumber}
                            disabled='true'
                            autoComplete='off'
                            value={this.state.contractNumber}
                            maxLength='4'
                          />
                        </div>
                      </div>
                    </div>

                    <div className='form-row'>
                      <div className='form-group col-lg-4 col-md-12 col-sm-12 d-flex'>
                        <label className='rsee-form-label col-2 text-right'>
                          {locales('cafes.type')}
                        </label>
                        <div className='full-width d-flex justify-content-between'>
                          <div className='d-flex col-12 justify-content-start'>
                            {ENUMS.CAFE_TYPE.list.map(type => (
                              <div
                                className='form-check col-6'
                                key={type.value}
                              >
                                <label
                                  className='form-check-label px-1'
                                  htmlFor={'cafeType' + type.value}
                                >
                                  {type.title}
                                </label>
                                <input
                                  className='form-check-input'
                                  type='radio'
                                  name='cafeType'
                                  id={'cafeType' + type.value}
                                  value={type.value}
                                  checked={this.state.cafeType === type.value}
                                  disabled
                                />
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                      <div
                        className={`form-group col-lg-4 col-md-12 col-sm-12 d-flex ${this
                          .state.cafeType === 'NORMAL' && 'required'}`}
                      >
                        <label
                          className='rsee-form-label col-3 text-right'
                          htmlFor='totalCafeTables'
                        >
                          {locales('fields.rsee.totalCafeTables')}
                        </label>
                        <div className='full-width'>
                          <input
                            id='totalCafeTables'
                            name='totalCafeTables'
                            type='text'
                            className={`form-control`}
                            // onChange={this.handleChangeTotalCafeTables}
                            autoComplete='off'
                            value={this.state.totalCafeTables}
                            readOnly
                          />
                        </div>
                      </div>
                      <div className='form-group col-lg-4 col-md-12 col-sm-12 d-flex'>
                        <label
                          className='rsee-form-label col-3 text-right'
                          htmlFor='totalRseeTables'
                        >
                          {locales('fields.rsee.totalRseeTables')}
                        </label>
                        <div className='full-width'>
                          <input
                            id='totalRseeTables'
                            name='totalRseeTables'
                            type='text'
                            className={`form-control`}
                            value={this.state.totalRseeTables}
                            readOnly
                          />
                        </div>
                      </div>
                    </div>

                    <div className='form-row'>
                      <div className='form-group col-lg-4 col-md-12 col-sm-12 d-flex required'>
                        <label
                          className='rsee-form-label col-3 text-right'
                          htmlFor='cities'
                        >
                          {locales('the.duration.of.each.reservation')}
                        </label>
                        <div className='full-width'>
                          <Select
                            placeholder={ENUMS.RESERVE_DURATION.list.map(
                              time =>
                                time.value === this.state.timeInterval &&
                                time.title,
                            )}
                            isMulti={false}
                            id='timeInterval'
                            name='timeInterval'
                            options={ENUMS.RESERVE_DURATION.list?.map(time => ({
                              label: time.title,
                              value: time.value,
                            }))}
                            onChange={selected =>
                              this.onTimeIntervalChange(selected)
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div id='financial-info'>
                    <h6 className='cafes-line-container text-primary'>
                      <span className='line'>
                        <i className='fal fa-coins px-1' />
                        {locales('title.financial.informations')}
                        <i className='fal fa-coins px-1' />
                      </span>
                    </h6>
                    <div className='form-row'>
                      {/* <div className='form-group col-lg-6 col-md-12 col-sm-12 d-flex'>
                        <label className='rsee-form-label col-2 text-right'>
                          {locales('labels.rsee.stock.type')}
                        </label>
                        <div className='full-width d-flex justify-content-between'>
                          <div className='d-flex justify-content-start col-12'>
                            {ENUMS.RSEE_STOCK_TYPE.list.map(type => (
                              <div className='form-check' key={type.value}>
                                <label
                                  className={`form-check-label px-1 
                                  ${this.state.rseeStockType === '' &&
                                    'text-secondary'}`}
                                  htmlFor={'rseeStockType' + type.value}
                                >
                                  {type.title}
                                </label>
                                <input
                                  className='form-check-input'
                                  type='radio'
                                  name='rseeStockType'
                                  id={'rseeStockType' + type.value}
                                  value={type.value}
                                  checked={
                                    this.state.rseeStockType === type.value
                                  }
                                  disabled
                                />
                              </div>
                            ))}
                          </div>
                          <div className='col-8'>
                            <p className='text-danger'>
                              {this.state.changeRseeStockTypeWarningText}
                            </p>
                          </div>
                        </div>
                      </div> */}
                      <div className='form-group col-lg-6 col-md-12 col-sm-12 d-flex'>
                        <label
                          className='rsee-form-label col-5 text-right'
                          for='hasRseeFee'
                        >
                          {locales('title.has.no.reservation.fee')}
                        </label>
                        <div className='full-width d-flex justify-content-between'>
                          <div className='d-flex justify-content-start col-12'>
                            <input
                              id='hasRseeFee'
                              type='checkbox'
                              className={`form-check-input`}
                              checked={this.state.hasNoReservationFee}
                              onChange={event =>
                                this.setState({
                                  hasNoReservationFee: event.target.checked,
                                })
                              }
                              disabled={this.state.cafeType === 'TAKEAWAY'}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className={`form-group col-lg-6 col-md-12 col-sm-12 d-flex ${this
                          .state.cafeType === 'TAKEAWAY' && 'required'}`}
                      >
                        <label
                          className='rsee-form-label col-2 text-right'
                          htmlFor='charge'
                        >
                          {locales('three.month.charge.amount')}
                        </label>
                        <div className='full-width'>
                          <div className='input-group mb-2'>
                            <div className='input-group-prepend'>
                              <div className='input-group-text'>
                                {enumHelper.convertEnumValueToTitle(
                                  ENUMS.CURRENCY.list,
                                  currency,
                                )}
                              </div>
                            </div>
                            <input
                              id='charge'
                              name='charge'
                              type='text'
                              className={`form-control ${this.state.chargeAmountFor3MonthInputValidateStatus}`}
                              onChange={this.onchargeChange}
                              autoComplete='off'
                              value={this.state.chargeAmountFor3Month?.toLocaleString()}
                              disabled={this.state.cafeType === 'NORMAL'}
                            />
                            <div className='invalid-feedback'>
                              {
                                this.state
                                  .chargeAmountFor3MonthInputInvalidMessage
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className='form-row'>
                      <div
                        className={`form-group col-lg-6 col-md-12 col-sm-12 d-flex ${this
                          .state.cafeType === 'NORMAL' && 'required'}`}
                      >
                        <label
                          className='rsee-form-label col-2 text-right'
                          htmlFor='name'
                        >
                          {locales('fields.cafe.minCheckout')}
                        </label>
                        <div className='full-width'>
                          <div className='input-group mb-2'>
                            <div className='input-group-prepend'>
                              <div className='input-group-text'>
                                {enumHelper.convertEnumValueToTitle(
                                  ENUMS.CURRENCY.list,
                                  currency,
                                )}
                              </div>
                            </div>
                            <input
                              id='minCheckout'
                              name='minCheckout'
                              type='text'
                              className={`form-control ${this.state.minCheckoutInputValidateStatus}`}
                              onChange={this.onMinChekoutChange}
                              autoComplete='off'
                              value={this.state.minCheckout.toLocaleString()}
                              // placeholder={locales(
                              //   'messages.rsee.minCheckout.help.text',
                              // )}
                              disabled={this.state.cafeType === 'TAKEAWAY'}
                            />
                            <div className='invalid-feedback'>
                              {this.state.minCheckoutInputInvalidMessage}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className={`form-group col-lg-6 col-md-12 col-sm-12 d-flex ${this
                          .state.cafeType === 'NORMAL' && 'required'}`}
                      >
                        <label
                          className='rsee-form-label col-2 text-right'
                          htmlFor='prePayForEachPersonPerHout'
                        >
                          {locales('titles.prePayForEachPersonPerHour')}
                        </label>
                        <div className='full-width'>
                          <div className='input-group mb-2'>
                            <div className='input-group-prepend'>
                              <div className='input-group-text'>
                                {enumHelper.convertEnumValueToTitle(
                                  ENUMS.CURRENCY.list,
                                  currency,
                                )}
                              </div>
                            </div>
                            <input
                              name='prePayForEachPersonPerHout'
                              id='prePayForEachPersonPerHout'
                              onChange={this.changePrePayForEachPersonPerHour}
                              value={prePayForEachPersonPerHour.toLocaleString()}
                              type='text'
                              className={`form-control ${this.state.prePayForEachPersonPerHourValidStatus}`}
                              disabled={this.state.cafeType === 'TAKEAWAY'}
                            />
                            <div className='invalid-feedback'>
                              {
                                this.state
                                  .prePayForEachPersonPerHourInvalidMessage
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className='form-row'>
                      <div
                        className={`form-group col-lg-6 col-md-12 col-sm-12 d-flex 
                      ${this.state.rseeStockType === 'RSEE_PERCENT' &&
                        this.state.cafeType === 'NORMAL' &&
                        'required'}`}
                      >
                        <label
                          className='rsee-form-label col-2 text-right'
                          htmlFor='rseePercent'
                        >
                          {locales('fields.rsee.percent')}
                        </label>
                        <div className='full-width'>
                          <input
                            id='rseePercent'
                            name='rseePercent'
                            type='number'
                            className={`form-control ${this.state.rseePercentInputValidateStatus}`}
                            onChange={e => this.onRseePercentChange(e)}
                            autoComplete='off'
                            value={this.state.rseePercent}
                            // readOnly={
                            //   this.state.rseeStockType === 'RSEE_AMOUNT' &&
                            //   'true'
                            // }
                            // disabled={
                            //   this.state.rseeStockType === 'RSEE_AMOUNT' ||
                            //   this.state.cafeType === 'TAKEAWAY'

                            // }
                            disabled='true'
                            readOnly='true'
                          />
                          <small className='form-text text-muted'>
                            {locales('messages.rsee.percent.help.text')}
                          </small>
                          <div className='invalid-feedback'>
                            {this.state.rseePercentInputInvalidMessage}
                          </div>
                        </div>
                      </div>

                      <div
                        className={`form-group col-lg-6 col-md-12 col-sm-12 d-flex 
                      ${this.state.rseeStockType === 'RSEE_AMOUNT' &&
                        this.state.cafeType === 'NORMAL' &&
                        'required'}`}
                      >
                        <label
                          className='rsee-form-label col-2 text-right'
                          htmlFor='rseePercent'
                        >
                          {locales('fields.rsee.stock.amount')}
                        </label>
                        <div className='full-width'>
                          <div className='input-group'>
                            <div className='input-group-prepend'>
                              <div className='input-group-text'>
                                {enumHelper.convertEnumValueToTitle(
                                  ENUMS.CURRENCY.list,
                                  currency,
                                )}
                              </div>
                            </div>
                            <input
                              id='rseeStockAmount'
                              name='rseeStockAmount'
                              type='text'
                              className={`form-control ${this.state.rseeConstantAmountInputValidateStatus}`}
                              onChange={e => this.onRseeConstantAmountChange(e)}
                              autoComplete='off'
                              value={this.state.rseeConstantAmount.toLocaleString()}
                            />
                          </div>
                          <small className='form-text text-muted'>
                            {locales('messages.rsee.stock.amount.help.text')}
                          </small>
                          <div className='invalid-feedback'>
                            {this.state.rseeConstantAmountInputInvalidMessage}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {this.state.cafeType === 'NORMAL' && (
                    <div id='cafe-meals'>
                      <h6 className='cafes-line-container text-primary'>
                        <span className='line'>
                          <i class='fal fa-clock px-1' />
                          {locales('labels.meals')}
                          <i class='fal fa-clock px-1' />
                        </span>
                      </h6>
                      <div className='form-row'>
                        <div className='form-group col d-flex'>
                          <label className='rsee-form-label col-1 text-right'>
                            {locales('fields.day.meals.hour')}
                          </label>
                          <div className='full-width d-flex'>
                            <div
                              className={`border rounded flex-fill ${styles.mealTimeBox}`}
                            >
                              <div
                                className={`form-check-inline ${styles.mealCheckContainer}`}
                              >
                                <label className='form-check-label'>
                                  <input
                                    type='checkbox'
                                    className='form-check-input'
                                    checked={this.state.hasBreakfast}
                                    onChange={this.onChangeHasBreakfast}
                                    disabled={
                                      this.state.cafeType === 'TAKEAWAY'
                                    }
                                  />
                                  {locales('labels.meals.breakfast')}
                                </label>
                              </div>
                              <label className={styles.fromTimeLabel}>
                                {locales('fields.from')}
                              </label>
                              <RseeTimePicker
                                onChange={this.onChangeBreakfastFromTime}
                                value={this.state.breakfastFromTime}
                                disabled={!this.state.hasBreakfast}
                                className={styles.fromTimePicker}
                              />
                              <label className={styles.toTimeLabel}>
                                {locales('fields.to')}
                              </label>
                              <RseeTimePicker
                                onChange={this.onChangeBreakfastToTime}
                                value={this.state.breakfastToTime}
                                disabled={!this.state.hasBreakfast}
                                className={styles.toTimePicker}
                              />
                              <div
                                className={`invalid-feedback ${
                                  !!this.state.breakfastInputError
                                    ? 'is-invalid-feedback'
                                    : ''
                                }`}
                              >
                                {this.state.breakfastInputError}
                              </div>
                            </div>
                            <div
                              className={`border rounded flex-fill ${styles.mealTimeBox}`}
                            >
                              <div
                                className={`form-check-inline ${styles.mealCheckContainer}`}
                              >
                                <label className='form-check-label'>
                                  <input
                                    type='checkbox'
                                    className='form-check-input'
                                    checked={this.state.hasLunch}
                                    onChange={this.onChangeHasLunch}
                                    disabled={
                                      this.state.cafeType === 'TAKEAWAY'
                                    }
                                  />
                                  {locales('labels.meals.lunch')}
                                </label>
                              </div>
                              <label className={styles.fromTimeLabel}>
                                {locales('fields.from')}
                              </label>
                              <RseeTimePicker
                                onChange={this.onChangeLunchFromTime}
                                value={this.state.lunchFromTime}
                                disabled={!this.state.hasLunch}
                                className={styles.fromTimePicker}
                              />
                              <label className={styles.toTimeLabel}>
                                {locales('fields.to')}
                              </label>
                              <RseeTimePicker
                                onChange={this.onChangeLunchToTime}
                                value={this.state.lunchToTime}
                                disabled={!this.state.hasLunch}
                                className={styles.toTimePicker}
                              />
                              <div
                                className={`invalid-feedback ${
                                  !!this.state.lunchInputError
                                    ? 'is-invalid-feedback'
                                    : ''
                                }`}
                              >
                                {this.state.lunchInputError}
                              </div>
                            </div>
                            <div
                              className={`border rounded flex-fill ${styles.mealTimeBox}`}
                            >
                              <div
                                className={`form-check-inline ${styles.mealCheckContainer}`}
                              >
                                <label className='form-check-label'>
                                  <input
                                    type='checkbox'
                                    className='form-check-input'
                                    checked={this.state.hasDinner}
                                    onChange={this.onChangeHasDinner}
                                    disabled={
                                      this.state.cafeType === 'TAKEAWAY'
                                    }
                                  />
                                  {locales('labels.meals.dinner')}
                                </label>
                              </div>
                              <label className={styles.fromTimeLabel}>
                                {locales('fields.from')}
                              </label>
                              <RseeTimePicker
                                onChange={this.onChangeDinnerFromTime}
                                value={this.state.dinnerFromTime}
                                disabled={!this.state.hasDinner}
                                className={styles.fromTimePicker}
                              />
                              <label className={styles.toTimeLabel}>
                                {locales('fields.to')}
                              </label>
                              <RseeTimePicker
                                onChange={this.onChangeDinnerToTime}
                                value={this.state.dinnerToTime}
                                disabled={!this.state.hasDinner}
                                className={styles.toTimePicker}
                              />
                              <div
                                className={`invalid-feedback ${
                                  !!this.state.dinnerInputError
                                    ? 'is-invalid-feedback'
                                    : ''
                                }`}
                              >
                                {this.state.dinnerInputError}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className='form-row'>
                        <div className='form-group col d-flex'>
                          <label
                            className='rsee-form-label col-1 text-right'
                            htmlFor='description'
                          >
                            {locales('fields.description')}
                          </label>
                          <div className='full-width'>
                            <input
                              id='description'
                              name='description'
                              type='text'
                              className='form-control'
                              onChange={this.onDescriptionChange}
                              autoComplete='off'
                              value={this.state.description}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  <div id='geo-location'>
                    <h6 className='cafes-line-container text-primary'>
                      <span className='line'>
                        <i className='fal fa-map-marker-alt px-1' />
                        {locales('titles.geo.location')}
                        <i className='fal fa-map-marker-alt px-1' />
                      </span>
                    </h6>
                    <div className='form-row'>
                      <div className='form-group col d-flex'>
                        <label
                          className='rsee-form-label col-1 text-right'
                          htmlFor='address'
                        >
                          {locales('fields.address')}
                        </label>
                        <div className='full-width'>
                          <input
                            id='address'
                            name='address'
                            type='text'
                            className='form-control'
                            onChange={this.onAddressChange}
                            autoComplete='off'
                            value={this.state.address}
                          />
                          <small className='form-text text-muted'>
                            {locales('messages.sample.cafe.address')}
                          </small>
                        </div>
                      </div>
                    </div>
                    <div className='form-row'>
                      <label className='rsee-form-label-full-width '>
                        {locales('fields.cafe.shop.geo.locaion')}
                      </label>
                      <div id='map-container'>
                        <MapComponent
                          latitude={this.state.latitude}
                          longitude={this.state.longitude}
                          onSelectCafeLocation={this.onSelectCafeLocation}
                        />
                        <small className='form-text text-muted'>
                          {locales(
                            'messages.hint.select.cafe.geo.location.on.map',
                          )}
                        </small>
                      </div>
                    </div>
                    <div className='form-row'>
                      <div className='form-group col d-flex required'>
                        <label
                          className='rsee-form-label col-1 text-right'
                          htmlFor='regions'
                        >
                          {locales('fields.regions')}
                        </label>
                        <div className='full-width'>
                          <Select
                            id='regions'
                            name='regions'
                            className={`rc-dropdown ${this.state.regionsInputValidateStatus}`}
                            placeholder={locales('messages.select.regions')}
                            formatCreateLabel={userInput =>
                              `اضافه کردن منطقه جدید:  ${userInput}`
                            }
                            isMulti={true}
                            options={this.props.regions.map(x => ({
                              value: x.id,
                              label: x.name,
                            }))}
                            onChange={this.onSelectRegions}
                            value={this.state.regions}
                          />
                          <div className='invalid-feedback'>
                            {this.state.regionsInputInvalidMessage}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div id='hours-and-call-items'>
                    <h6 className='cafes-line-container text-primary'>
                      <span className='line'>
                        <i className='fal fa-id-card px-1' />
                        {locales('titles.workingHoursAndContactInformation')}
                        <i className='fal fa-id-card px-1' />
                      </span>
                    </h6>
                    <div className='d-flex'>
                      <div className='col'>
                        <h6 className='d-flex justify-content-center text-muted'>
                          {locales('messages.workingHours')}
                        </h6>
                        <WorkingHoursList
                          className='col5'
                          workingHours={this.state.workingHours}
                          openEditWorkingHourModal={
                            this.openEditWorkingHourModal
                          }
                          deleteWorkingHourItem={this.deleteWorkingHourItem}
                          displayEditWorkingHourItemModal={
                            this.displayEditWorkingHourItemModal
                          }
                          displayAddWorkingHourModal={
                            this.displayAddWorkingHourModal
                          }
                        />
                      </div>
                      <div className='col'>
                        <h6 className='d-flex justify-content-center text-muted'>
                          {locales('titles.contact.items')}
                        </h6>
                        <ContactsList
                          contacts={this.state.contacts}
                          openEditContactModal={this.openEditContactModal}
                          deleteContactItem={this.deleteContactItem}
                          displayEditContactItemModal={
                            this.displayEditContactItemModal
                          }
                          displayContactModal={this.displayContactModal}
                        />
                      </div>
                    </div>
                  </div>

                  {this.state.cafeType === 'NORMAL' && (
                    <div id='cafe-services'>
                      <h6 className='cafes-line-container text-primary'>
                        <span className='line'>
                          <i className='fal fa-concierge-bell px-1' />
                          {locales('titles.services')}
                          <i className='fal fa-concierge-bell px-1' />
                        </span>
                      </h6>
                      <div className='d-flex py-2'>
                        <label
                          className='rsee-form-label col-1 text-right'
                          htmlFor='name'
                        >
                          {locales('title.cafes.amenities')}
                        </label>
                        <Select
                          placeholder={locales('messages.select.amenities')}
                          isMulti={true}
                          options={this.props.amenities.map(x => ({
                            value: x.id,
                            label: x.name,
                          }))}
                          className='full-width'
                          onChange={this.onSelectAmenities}
                          value={this.state.amenities}
                        />
                      </div>
                      <div className='col'>
                        <h6
                          className='d-flex justify-content-center text-muted'
                          onClick={this.displayAddTableItemModal}
                        >
                          {locales('messages.rseeTables')}
                        </h6>
                        <TablesList
                          tables={this.state.tables}
                          deleteTableItem={this.deleteTableItem}
                          displayEditTableItemModal={
                            this.displayEditTableItemModal
                          }
                          cafeType={this.state.cafeType}
                          displayAddTableItemModal={
                            this.displayAddTableItemModal
                          }
                        />
                      </div>
                    </div>
                  )}

                  <div id='cafe-images'>
                    <h6 className='cafes-line-container text-primary'>
                      <span className='line'>
                        <i className='fal fa-image px-1' />
                        {locales('titles.cafe.images')}
                        <i className='fal fa-image px-1' />
                      </span>
                    </h6>
                    <div>
                      <ImageUploader
                        placeholder={locales('fields.cafe.logo.image')}
                        actionUrl={`${API_ENDPOINT}/v1/general/upload-cafe-logo`}
                        imageFile={this.state.logoUrl}
                        isMulti={false}
                        onUploadSuccess={this.onUploadLogoSuccess}
                        deleteImage={this.deleteLogo}
                        fileName={this.state.logoFileName}
                      />
                    </div>
                    <ImageUploader
                      placeholder={'انتخاب تصویرهای کافه'}
                      actionUrl={`${API_ENDPOINT}/v1/cafe/upload-cafe-images`}
                      imageFile={this.state.cafeImages}
                      isMulti={true}
                      onUploadSuccess={this.onUploadCafeImagesSuccess}
                      deleteImage={this.deleteCafeImage}
                    />
                    <ImageUploader
                      placeholder={locales('fields.table.location.image')}
                      actionUrl={`${API_ENDPOINT}/v1/general/upload-location-table`}
                      imageFile={this.state.locationTableUrl}
                      isMulti={false}
                      onUploadSuccess={this.onUploadLocationTableSuccess}
                      deleteImage={this.deleteLocationTable}
                      fileName={this.state.locationTableFileName}
                    />
                  </div>
                </section>
              </form>
            </div>
          </section>
        </Spin>

        {this.state.displayTableModal && (
          <AddOrEditTableModal
            isOpen={this.state.displayTableModal}
            tableModalRenderFlag={this.state.tableModalRenderFlag}
            editMode={this.state.tableModalEditMode}
            itemKey={this.state.tableModalEditData.itemKey}
            num={this.state.tableModalEditData.num}
            totalChairs={this.state.tableModalEditData.totalChairs}
            allowSmoking={this.state.tableModalEditData.allowSmoking}
            haveHeatSystem={this.state.tableModalEditData.haveHeatSystem}
            floor={this.state.tableModalEditData.floor}
            location={this.state.tableModalEditData.location}
            closeModal={this.closeTableModal}
            addTableItem={this.addTableItem}
            editTableItem={this.editTableItem}
            isTableNumDuplicate={this.isTableNumDuplicate}
            handlePlusTotalRseeTables={this.handlePlusTotalRseeTables}
            tables={this.state.tables}
            tableTitle={this.state.tableModalEditData.tableTitle}
            hasCoolingSystem={this.state.tableModalEditData.hasCoolingSystem}
            hasFogSpray={this.state.tableModalEditData.hasFogSpray}
            hasInput={this.state.tableModalEditData.hasInput}
            inputAmount={this.state.tableModalEditData.inputAmount}
          />
        )}

        {this.state.isContactModalOpen && (
          <AddOrEditContactModal
            isOpen={this.state.isContactModalOpen}
            editMode={this.state.contactModalEditMode}
            itemKey={this.state.contactModalEditData.itemKey}
            type={this.state.contactModalEditData.type}
            value={this.state.contactModalEditData.value}
            closeModal={this.closeContactModal}
            addContactItem={this.addContactItem}
            editContactItem={this.editContactItem}
            isContactItemDuplicate={this.isContactItemDuplicate}
          />
        )}

        {this.state.isWorkingHourModalOpen && (
          <AddOrEditWorkingHourModal
            isOpen={this.state.isWorkingHourModalOpen}
            editMode={this.state.workingHourModalEditMode}
            itemKey={this.state.workingHourModalEditData.itemKey}
            day={this.state.workingHourModalEditData.day}
            fromTime={this.state.workingHourModalEditData.fromTime}
            toTime={this.state.workingHourModalEditData.toTime}
            closeModal={this.closeWorkingHourModal}
            addWorkingHourItem={this.addWorkingHourItem}
            editWorkingHourItem={this.editWorkingHourItem}
            isWorkingHourItemDuplicate={this.isWorkingHourItemDuplicate}
          />
        )}
      </AddOrEditCafeContext.Provider>
    );
  }
}

const mapStateToProps = state => {
  const {
    amenities,
    regions,
    getAmenitiesLoading,
    getRegionsLoading,
    addOrEditCafeLoading,
    addOrEditCafeFailed,
    addOrEditCafeError,
    addOrEditCafeFailedMessagesList,

    getCafeByIdLoading,
    getCafeByIdFailed,
    getCafeByIdError,
    getCafeByIdMessage,
    fetchedCafeById,
    cafesContract,
    getCafesContractLoading,
  } = state.cafesReducer;

  return {
    amenities,
    regions,
    addOrEditCafeLoading,
    addOrEditCafeFailed,
    addOrEditCafeError,
    addOrEditCafeFailedMessagesList,

    getAmenitiesLoading,
    getRegionsLoading,

    getCafeByIdLoading,
    getCafeByIdFailed,
    getCafeByIdError,
    getCafeByIdMessage,
    fetchedCafeById,
    cafesContract,
    getCafesContractLoading,
  };
};

const mapDispatchToProps = dispatch => ({
  actions: {
    getAmenities: () => dispatch(cafeActions.getAmenities()),
    getRegions: (id, query) => dispatch(cafeActions.getRegions(id, query)),
    insertNewCafe: cafeObject => dispatch(cafeActions.insertCafe(cafeObject)),
    updateCafe: cafeObject => dispatch(cafeActions.updateCafe(cafeObject)),
    getCafeById: cafeId => dispatch(cafeActions.getCafeById(cafeId)),
    getCafeContract: () => dispatch(cafeActions.getAllCafeContract()),
    clearForm: () => dispatch(cafeActions.clearAddOrEditCafeForm()),
    changeCafeStatus: (status, rejectReason, cafeId) =>
      dispatch(
        introducedCafesActions.changeCafeStatus(status, rejectReason, cafeId),
      ),
  },
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AddOrEditCafe),
);
